import { ACCOUNT_SEARCH_LINK_DETAILS, ACCOUNT_SEARCH_LINK_DETAILS_SUCCESS, ACCOUNT_SEARCH_LINK_DETAILS_FAILURE, CLEAR_ACCOUNT_SEARCH_LINK_DETAILS } from '../actions/actionTypes'
const accountSearchLinkReducer = (state = { data: null, isLoading: false, error: null }, actionPayload = { type: null, payload: null }) => {
  const { type, payload } = actionPayload
  switch (type) {
    case ACCOUNT_SEARCH_LINK_DETAILS:
      return {
        ...state,
        status: null,
        isLoading: true
      }
    case ACCOUNT_SEARCH_LINK_DETAILS_SUCCESS:
      return {
        ...state,
        data: payload,
        status: true,
        error: null,
        isLoading: false
      }
    case ACCOUNT_SEARCH_LINK_DETAILS_FAILURE:
      return {
        ...state,
        status: false,
        error: payload,
        isLoading: false
      }
    case CLEAR_ACCOUNT_SEARCH_LINK_DETAILS:
      return {
        ...state,
        status: null,
        isLoading: false
      }
    default:
      return state
  }
}

export default accountSearchLinkReducer
